import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";
import CG_Header from "./CG_Header";
import { useNavigate } from "react-router-dom";

export default function CG_PreviewContract() {
    const navigate = useNavigate();
    return (
        <div className="">
            <CG_Header screen="preview-contract" />
            <div className="tw-p-10 tw-px-[5%] tw-text-[#001659]">
                <h1 className="tw-underline tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Preview your contract</h1>
                <div className="tw-w-full tw-mt-5">
                    <div className="tw-flex tw-flex-col xl:tw-flex-row tw-gap-10">
                        <div className="tw-w-full xl:tw-w-1/2">
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Basic Information</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full tw-mt-10">
                                <p className="tw-font-[800]">Property Details:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full tw-mt-10">
                                <p className="tw-font-[800]">Offer Details:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tw-w-full xl:tw-w-1/2">
                            <div className="tw-w-full">
                                <p className="tw-font-[800]">Financing Information</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-w-full tw-mt-10">
                                <p className="tw-font-[800]"> Additional terms & Conditions:</p>
                                <div className="tw-bg-[#F1F1F1] tw-p-3 tw-rounded-md tw-flex-col tw-flex tw-gap-2">
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Name:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Contact:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Email:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                    <div className="tw-bg-white tw-rounded tw-text-[#666666] tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 ">
                                        <p className="tw-font-[600]">Nationality:</p>
                                        <p>ABC XYZ</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CG_FooterButtons screen="preview" navigate={navigate} />
            </div>
        </div>
    );
}
